import React from 'react';
import { Box, Button, Container, Stack, Typography, useTheme, alpha } from '@mui/material';
import { ArrowBack, SupportAgent } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import Seo from './Seo';

const NotFoundPage = () => {
  const theme = useTheme();

  return (
    <>
      <Seo
        title="Page not found | SSIPL"
        description="The page you are looking for could not be found."
        path="/404"
        robots="noindex, follow"
      />
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          backgroundColor: 'background.default'
        }}
      >
        <Box aria-hidden sx={{ position: 'absolute', inset: 0, background: theme.surfaces.aurora }} />
        <Box
          aria-hidden
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundImage: theme.surfaces.grid,
            backgroundSize: theme.surfaces.gridSize,
            maskImage: 'radial-gradient(circle at 50% 50%, #000 0%, transparent 70%)',
            WebkitMaskImage: 'radial-gradient(circle at 50% 50%, #000 0%, transparent 70%)'
          }}
        />

        <Container maxWidth="sm" sx={{ position: 'relative', textAlign: 'center', py: 10 }}>
          <Typography
            component="p"
            sx={{
              fontSize: 'clamp(4.5rem, 18vw, 8rem)',
              fontWeight: 900,
              lineHeight: 1,
              letterSpacing: '-0.05em',
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent'
            }}
          >
            404
          </Typography>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 800, mt: 2, mb: 2 }}>
            This page could not be found
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 5, lineHeight: 1.8 }}>
            The page you are looking for may have been moved or no longer exists. Let us get you back on track.
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
            <Button component={RouterLink} to="/" variant="contained" size="large" startIcon={<ArrowBack />} sx={{ fontWeight: 700 }}>
              Back to Home
            </Button>
            <Button
              component="a"
              href="mailto:info@ssipl.lk"
              variant="outlined"
              size="large"
              startIcon={<SupportAgent />}
              sx={{ fontWeight: 700, borderColor: alpha(theme.palette.primary.main, 0.4) }}
            >
              Contact Support
            </Button>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default NotFoundPage;
